module.exports = __webpack_public_path__ + "static/media/homeIcon.fc112fee.svg";